// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeadTasksView-module__root___Wu6_j {
  min-width: 0;
}

.LeadTasksView-module__toolbar___QotMt {
  align-items: center;
  border-bottom: 1px solid #dce5df;
  display: flex;
  gap: 8px;
  padding: 12px 0;
}

.LeadTasksView-module__toolbar___QotMt select,
.LeadTasksView-module__search___IL66f {
  background: #fff;
  border: 1px solid #aebdb4;
  border-radius: 4px;
  color: #243b31;
  height: 38px;
}

.LeadTasksView-module__toolbar___QotMt select {
  padding: 0 30px 0 10px;
}

.LeadTasksView-module__search___IL66f {
  align-items: center;
  display: flex;
  flex: 1;
  gap: 8px;
  max-width: 520px;
  padding: 0 10px;
}

.LeadTasksView-module__search___IL66f input {
  border: 0;
  color: inherit;
  flex: 1;
  min-width: 0;
  outline: 0;
}

.LeadTasksView-module__iconButton___DYYUQ {
  align-items: center;
  background: #fff;
  border: 1px solid #aebdb4;
  border-radius: 4px;
  color: #315c49;
  display: inline-flex;
  height: 38px;
  justify-content: center;
  width: 38px;
}

.LeadTasksView-module__workspace___skVg0 {
  display: grid;
  grid-template-columns: minmax(280px, 360px) minmax(0, 1fr);
  min-height: 620px;
}

.LeadTasksView-module__taskList___KPjjm {
  border-right: 1px solid #dce5df;
  min-width: 0;
  padding: 14px 14px 14px 0;
}

.LeadTasksView-module__listHeader___ymHFx {
  color: #52655c;
  display: flex;
  font-size: 12px;
  font-weight: 700;
  justify-content: space-between;
  padding: 0 8px 10px;
  text-transform: uppercase;
}

.LeadTasksView-module__taskRow___tp9Fq {
  background: transparent;
  border: 0;
  border-bottom: 1px solid #e6ece8;
  color: #243b31;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 10px;
  text-align: left;
  width: 100%;
}

.LeadTasksView-module__taskRow___tp9Fq:hover,
.LeadTasksView-module__selected___NSBOW {
  background: #f1f6f3;
}

.LeadTasksView-module__selected___NSBOW {
  box-shadow: inset 3px 0 #287a57;
}

.LeadTasksView-module__taskSubject___c7pao {
  font-size: 14px;
  font-weight: 700;
}

.LeadTasksView-module__leadName___K3975 {
  font-size: 13px;
}

.LeadTasksView-module__taskMeta___C5u7z {
  color: #66776f;
  display: flex;
  font-size: 11px;
  gap: 10px;
  justify-content: space-between;
}

.LeadTasksView-module__detail___i6CK3 {
  min-width: 0;
  padding: 20px 0 40px 24px;
}

.LeadTasksView-module__detailHeader___snBre {
  align-items: flex-start;
  border-bottom: 1px solid #dce5df;
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
}

.LeadTasksView-module__detailHeader___snBre h2 {
  color: #20372d;
  font-size: 20px;
  margin: 3px 0 4px;
}

.LeadTasksView-module__detailHeader___snBre p {
  color: #52655c;
  margin: 0;
}

.LeadTasksView-module__eyebrow___b4gGf {
  color: #678275;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.LeadTasksView-module__status___Kmm8u {
  background: #e8f1ec;
  border-radius: 4px;
  color: #315c49;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 8px;
}

.LeadTasksView-module__consentPanel___p_4Dy {
  align-items: center;
  background-color: #f2f6f3;
  border: 1px solid #dce5df;
  border-radius: 6px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-top: 16px;
  padding: 12px 14px;
}

.LeadTasksView-module__consentPanel___p_4Dy strong {
  font-size: 13px;
}

.LeadTasksView-module__consentPanel___p_4Dy p {
  color: #66776f;
  font-size: 12px;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
}

.LeadTasksView-module__taskStrip___Y7YX2 {
  border-bottom: 1px solid #dce5df;
  display: flex;
  flex-direction: column;
  padding: 12px 0;
}

.LeadTasksView-module__stripRow___MsjDb {
  align-items: center;
  background: none;
  border: 0;
  border-left: 2px solid transparent;
  cursor: pointer;
  display: flex;
  font-size: 13px;
  gap: 12px;
  justify-content: space-between;
  padding: 8px 10px;
  text-align: left;
  width: 100%;
}

.LeadTasksView-module__stripRow___MsjDb:hover {
  background-color: #f2f6f3;
}

.LeadTasksView-module__stripSelected___HUImJ {
  background-color: #eaf1ec;
  border-left-color: #2f6f4f;
  font-weight: 600;
}

.LeadTasksView-module__stripDone___xMm_m {
  color: #8a978f;
}

.LeadTasksView-module__stripMeta___WjHn6 {
  color: #66776f;
  flex-shrink: 0;
  font-size: 11px;
}

.LeadTasksView-module__summary___uHPYz {
  border-bottom: 1px solid #dce5df;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding: 16px 0;
}

.LeadTasksView-module__summary___uHPYz div {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.LeadTasksView-module__summary___uHPYz span {
  color: #66776f;
  font-size: 11px;
}

.LeadTasksView-module__summary___uHPYz strong {
  font-size: 13px;
  overflow-wrap: anywhere;
}

.LeadTasksView-module__actions___LGGj4 {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 0;
}

.LeadTasksView-module__primaryButton___KDKMf,
.LeadTasksView-module__dangerButton___JfMwR {
  align-items: center;
  border: 0;
  border-radius: 4px;
  color: #fff;
  display: inline-flex;
  font-weight: 700;
  gap: 6px;
  min-height: 36px;
  padding: 8px 12px;
}

.LeadTasksView-module__primaryButton___KDKMf {
  background: #287a57;
}

.LeadTasksView-module__dangerButton___JfMwR {
  background: #a33a3a;
}

.LeadTasksView-module__primaryButton___KDKMf:disabled,
.LeadTasksView-module__dangerButton___JfMwR:disabled {
  opacity: 0.6;
}

.LeadTasksView-module__assignedNotice___hAiXL,
.LeadTasksView-module__empty___QNHtl {
  color: #66776f;
  font-size: 13px;
  padding: 18px 10px;
}

.LeadTasksView-module__error___uJyif {
  background: #fff1f1;
  border-left: 3px solid #b83e3e;
  color: #7f2727;
  margin-top: 10px;
  padding: 10px 12px;
}

@media (max-width: 900px) {
  .LeadTasksView-module__toolbar___QotMt {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .LeadTasksView-module__search___IL66f {
    flex-basis: 100%;
    max-width: none;
  }
  .LeadTasksView-module__workspace___skVg0 {
    grid-template-columns: 1fr;
  }
  .LeadTasksView-module__taskList___KPjjm {
    border-bottom: 1px solid #dce5df;
    border-right: 0;
    max-height: 360px;
    overflow-y: auto;
    padding-right: 0;
  }
  .LeadTasksView-module__detail___i6CK3 {
    padding-left: 0;
  }
  .LeadTasksView-module__summary___uHPYz {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/LeadTasksView/LeadTasksView.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,mBAAA;EACA,gCAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;;EAEE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,0DAAA;EACA,iBAAA;AACF;;AAEA;EACE,+BAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;AACF;;AAEA;EACE,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;AACF;;AAEA;EACE,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,kCAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,0BAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,gCAAA;EACA,aAAA;EACA,SAAA;EACA,gDAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,uBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;;EAEE,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;EAEE,YAAA;AACF;;AAEA;;EAEE,cAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,oBAAA;IACA,eAAA;EACF;EAEA;IACE,gBAAA;IACA,eAAA;EAAF;EAGA;IACE,0BAAA;EADF;EAIA;IACE,gCAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EAFF;EAKA;IACE,eAAA;EAHF;EAMA;IACE,gDAAA;EAJF;AACF","sourcesContent":[".root {\n  min-width: 0;\n}\n\n.toolbar {\n  align-items: center;\n  border-bottom: 1px solid #dce5df;\n  display: flex;\n  gap: 8px;\n  padding: 12px 0;\n}\n\n.toolbar select,\n.search {\n  background: #fff;\n  border: 1px solid #aebdb4;\n  border-radius: 4px;\n  color: #243b31;\n  height: 38px;\n}\n\n.toolbar select {\n  padding: 0 30px 0 10px;\n}\n\n.search {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  gap: 8px;\n  max-width: 520px;\n  padding: 0 10px;\n}\n\n.search input {\n  border: 0;\n  color: inherit;\n  flex: 1;\n  min-width: 0;\n  outline: 0;\n}\n\n.iconButton {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #aebdb4;\n  border-radius: 4px;\n  color: #315c49;\n  display: inline-flex;\n  height: 38px;\n  justify-content: center;\n  width: 38px;\n}\n\n.workspace {\n  display: grid;\n  grid-template-columns: minmax(280px, 360px) minmax(0, 1fr);\n  min-height: 620px;\n}\n\n.taskList {\n  border-right: 1px solid #dce5df;\n  min-width: 0;\n  padding: 14px 14px 14px 0;\n}\n\n.listHeader {\n  color: #52655c;\n  display: flex;\n  font-size: 12px;\n  font-weight: 700;\n  justify-content: space-between;\n  padding: 0 8px 10px;\n  text-transform: uppercase;\n}\n\n.taskRow {\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid #e6ece8;\n  color: #243b31;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 14px 10px;\n  text-align: left;\n  width: 100%;\n}\n\n.taskRow:hover,\n.selected {\n  background: #f1f6f3;\n}\n\n.selected {\n  box-shadow: inset 3px 0 #287a57;\n}\n\n.taskSubject {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.leadName {\n  font-size: 13px;\n}\n\n.taskMeta {\n  color: #66776f;\n  display: flex;\n  font-size: 11px;\n  gap: 10px;\n  justify-content: space-between;\n}\n\n.detail {\n  min-width: 0;\n  padding: 20px 0 40px 24px;\n}\n\n.detailHeader {\n  align-items: flex-start;\n  border-bottom: 1px solid #dce5df;\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 16px;\n}\n\n.detailHeader h2 {\n  color: #20372d;\n  font-size: 20px;\n  margin: 3px 0 4px;\n}\n\n.detailHeader p {\n  color: #52655c;\n  margin: 0;\n}\n\n.eyebrow {\n  color: #678275;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.status {\n  background: #e8f1ec;\n  border-radius: 4px;\n  color: #315c49;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 6px 8px;\n}\n\n.consentPanel {\n  align-items: center;\n  background-color: #f2f6f3;\n  border: 1px solid #dce5df;\n  border-radius: 6px;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n  margin-top: 16px;\n  padding: 12px 14px;\n}\n\n.consentPanel strong {\n  font-size: 13px;\n}\n\n.consentPanel p {\n  color: #66776f;\n  font-size: 12px;\n  margin: 4px 0 0;\n  overflow-wrap: anywhere;\n}\n\n.taskStrip {\n  border-bottom: 1px solid #dce5df;\n  display: flex;\n  flex-direction: column;\n  padding: 12px 0;\n}\n\n.stripRow {\n  align-items: center;\n  background: none;\n  border: 0;\n  border-left: 2px solid transparent;\n  cursor: pointer;\n  display: flex;\n  font-size: 13px;\n  gap: 12px;\n  justify-content: space-between;\n  padding: 8px 10px;\n  text-align: left;\n  width: 100%;\n}\n\n.stripRow:hover {\n  background-color: #f2f6f3;\n}\n\n.stripSelected {\n  background-color: #eaf1ec;\n  border-left-color: #2f6f4f;\n  font-weight: 600;\n}\n\n.stripDone {\n  color: #8a978f;\n}\n\n.stripMeta {\n  color: #66776f;\n  flex-shrink: 0;\n  font-size: 11px;\n}\n\n.summary {\n  border-bottom: 1px solid #dce5df;\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  padding: 16px 0;\n}\n\n.summary div {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.summary span {\n  color: #66776f;\n  font-size: 11px;\n}\n\n.summary strong {\n  font-size: 13px;\n  overflow-wrap: anywhere;\n}\n\n.actions {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 16px 0;\n}\n\n.primaryButton,\n.dangerButton {\n  align-items: center;\n  border: 0;\n  border-radius: 4px;\n  color: #fff;\n  display: inline-flex;\n  font-weight: 700;\n  gap: 6px;\n  min-height: 36px;\n  padding: 8px 12px;\n}\n\n.primaryButton {\n  background: #287a57;\n}\n\n.dangerButton {\n  background: #a33a3a;\n}\n\n.primaryButton:disabled,\n.dangerButton:disabled {\n  opacity: 0.6;\n}\n\n.assignedNotice,\n.empty {\n  color: #66776f;\n  font-size: 13px;\n  padding: 18px 10px;\n}\n\n.error {\n  background: #fff1f1;\n  border-left: 3px solid #b83e3e;\n  color: #7f2727;\n  margin-top: 10px;\n  padding: 10px 12px;\n}\n\n@media (max-width: 900px) {\n  .toolbar {\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n\n  .search {\n    flex-basis: 100%;\n    max-width: none;\n  }\n\n  .workspace {\n    grid-template-columns: 1fr;\n  }\n\n  .taskList {\n    border-bottom: 1px solid #dce5df;\n    border-right: 0;\n    max-height: 360px;\n    overflow-y: auto;\n    padding-right: 0;\n  }\n\n  .detail {\n    padding-left: 0;\n  }\n\n  .summary {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `LeadTasksView-module__root___Wu6_j`,
	"toolbar": `LeadTasksView-module__toolbar___QotMt`,
	"search": `LeadTasksView-module__search___IL66f`,
	"iconButton": `LeadTasksView-module__iconButton___DYYUQ`,
	"workspace": `LeadTasksView-module__workspace___skVg0`,
	"taskList": `LeadTasksView-module__taskList___KPjjm`,
	"listHeader": `LeadTasksView-module__listHeader___ymHFx`,
	"taskRow": `LeadTasksView-module__taskRow___tp9Fq`,
	"selected": `LeadTasksView-module__selected___NSBOW`,
	"taskSubject": `LeadTasksView-module__taskSubject___c7pao`,
	"leadName": `LeadTasksView-module__leadName___K3975`,
	"taskMeta": `LeadTasksView-module__taskMeta___C5u7z`,
	"detail": `LeadTasksView-module__detail___i6CK3`,
	"detailHeader": `LeadTasksView-module__detailHeader___snBre`,
	"eyebrow": `LeadTasksView-module__eyebrow___b4gGf`,
	"status": `LeadTasksView-module__status___Kmm8u`,
	"consentPanel": `LeadTasksView-module__consentPanel___p_4Dy`,
	"taskStrip": `LeadTasksView-module__taskStrip___Y7YX2`,
	"stripRow": `LeadTasksView-module__stripRow___MsjDb`,
	"stripSelected": `LeadTasksView-module__stripSelected___HUImJ`,
	"stripDone": `LeadTasksView-module__stripDone___xMm_m`,
	"stripMeta": `LeadTasksView-module__stripMeta___WjHn6`,
	"summary": `LeadTasksView-module__summary___uHPYz`,
	"actions": `LeadTasksView-module__actions___LGGj4`,
	"primaryButton": `LeadTasksView-module__primaryButton___KDKMf`,
	"dangerButton": `LeadTasksView-module__dangerButton___JfMwR`,
	"assignedNotice": `LeadTasksView-module__assignedNotice___hAiXL`,
	"empty": `LeadTasksView-module__empty___QNHtl`,
	"error": `LeadTasksView-module__error___uJyif`
};
module.exports = ___CSS_LOADER_EXPORT___;
